(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6908],{

/***/ 70861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FT": function() { return /* binding */ useButtonProps; }
/* harmony export */ });
/* unused harmony export isTrivialHref */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
const _excluded = ["as", "disabled"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function isTrivialHref(href) {
  return !href || href.trim() === '#';
}
function useButtonProps({
  tagName,
  disabled,
  href,
  target,
  rel,
  role,
  onClick,
  tabIndex = 0,
  type
}) {
  if (!tagName) {
    if (href != null || target != null || rel != null) {
      tagName = 'a';
    } else {
      tagName = 'button';
    }
  }

  const meta = {
    tagName
  };

  if (tagName === 'button') {
    return [{
      type: type || 'button',
      disabled
    }, meta];
  }

  const handleClick = event => {
    if (disabled || tagName === 'a' && isTrivialHref(href)) {
      event.preventDefault();
    }

    if (disabled) {
      event.stopPropagation();
      return;
    }

    onClick == null ? void 0 : onClick(event);
  };

  const handleKeyDown = event => {
    if (event.key === ' ') {
      event.preventDefault();
      handleClick(event);
    }
  };

  if (tagName === 'a') {
    // Ensure there's a href so Enter can trigger anchor button.
    href || (href = '#');

    if (disabled) {
      href = undefined;
    }
  }

  return [{
    role: role != null ? role : 'button',
    // explicitly undefined so that it overrides the props disabled in a spread
    // e.g. <Tag {...props} {...hookProps} />
    disabled: undefined,
    tabIndex: disabled ? undefined : tabIndex,
    href,
    target: tagName === 'a' ? target : undefined,
    'aria-disabled': !disabled ? undefined : disabled,
    rel: tagName === 'a' ? rel : undefined,
    onClick: handleClick,
    onKeyDown: handleKeyDown
  }, meta];
}
const Button = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_ref, ref) => {
  let {
    as: asProp,
    disabled
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  const [buttonProps, {
    tagName: Component
  }] = useButtonProps(Object.assign({
    tagName: asProp,
    disabled
  }, props));
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Component, Object.assign({}, props, buttonProps, {
    ref: ref
  }));
});
Button.displayName = 'Button';
/* harmony default export */ __webpack_exports__["ZP"] = (Button);

/***/ }),

/***/ 91712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ FilterSelectorButtons_FilterSelectorButtons; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/models/travel/filter/TravelFilterNav/FilterSelectorButtons/FilterSelectorButtons.module.scss
var FilterSelectorButtons_module = __webpack_require__(75849);
var FilterSelectorButtons_module_default = /*#__PURE__*/__webpack_require__.n(FilterSelectorButtons_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 17 modules
var esm = __webpack_require__(66290);
;// CONCATENATED MODULE: ./src/components/models/travel/filter/TravelFilterNav/FilterSelectorButtons/FilterSelectorButtons.tsx





var FilterSelectorButtons = function(param) {
    var handleReset = param.handleReset, handleApply = param.handleApply;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
        className: "".concat((FilterSelectorButtons_module_default()).root, " mt-2"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
            xs: "auto",
            className: "ms-auto",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                variant: "signal",
                size: "sm",
                onClick: handleApply,
                className: "".concat((FilterSelectorButtons_module_default()).button, " ms-2"),
                children: t("travelFilter.filterInput.apply")
            })
        })
    });
};
/* harmony default export */ var FilterSelectorButtons_FilterSelectorButtons = (FilterSelectorButtons);

;// CONCATENATED MODULE: ./src/components/models/travel/filter/TravelFilterNav/FilterSelectorButtons/index.tsx



/***/ }),

/***/ 96908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ CheckboxFilterSelector_CheckboxFilterSelector; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/models/travel/filter/TravelFilterNav/selectors/CheckboxFilterSelector/CheckboxFilterSelector.module.scss
var CheckboxFilterSelector_module = __webpack_require__(69664);
var CheckboxFilterSelector_module_default = /*#__PURE__*/__webpack_require__.n(CheckboxFilterSelector_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Form.js + 11 modules
var Form = __webpack_require__(28431);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Badge.js
var Badge = __webpack_require__(27977);
// EXTERNAL MODULE: ./src/components/models/travel/filter/TravelFilterNav/FilterSelectorButtons/index.tsx + 1 modules
var FilterSelectorButtons = __webpack_require__(91712);
// EXTERNAL MODULE: ./src/integrations/tracking/useTracking.tsx + 4 modules
var useTracking = __webpack_require__(624);
;// CONCATENATED MODULE: ./src/components/models/travel/filter/TravelFilterNav/selectors/CheckboxFilterSelector/CheckboxFilterSelector.tsx







var buildOptionColumns = function(options) {
    var numberOfColumns = 3;
    var itemsPerColumn = Math.ceil(options.length / numberOfColumns);
    var columns = [];
    for(var i = 0; i < numberOfColumns; i++){
        columns.push(options.slice(i * itemsPerColumn, i * itemsPerColumn + itemsPerColumn));
    }
    return columns;
};
var CheckboxFilterSelector = function(param) {
    var filter = param.filter, selection = param.selection, setSelection = param.setSelection, applySelection = param.applySelection;
    var send = (0,useTracking/* useTracking */.r)().send;
    var optionColumns = buildOptionColumns(filter.options);
    var getIsSelected = function(value) {
        return !!selection.filter(function(selectionValue) {
            return selectionValue == value;
        }).length;
    };
    var handleChangeSelection = function(value) {
        var ref;
        var newSelection = (0,_to_consumable_array/* default */.Z)(selection);
        var index = newSelection.indexOf(value);
        var valueLabel = (ref = filter.options.find(function(option) {
            return option.value === value;
        })) === null || ref === void 0 ? void 0 : ref.label;
        if (index === -1) {
            // add
            newSelection.push(value);
            setSelection((0,_to_consumable_array/* default */.Z)(selection).concat([
                value
            ]));
            send.genericEvent({
                category: "travel_filter",
                object: "filter_option",
                action: "add",
                data: {
                    filter_type_name: filter.name,
                    filter_option_value: valueLabel
                }
            });
        } else {
            // remove
            newSelection.splice(index, 1);
            send.genericEvent({
                category: "travel_filter",
                object: "filter_option",
                action: "remove",
                data: {
                    filter_type_name: filter.name,
                    filter_option_value: valueLabel
                }
            });
        }
        setSelection(newSelection);
    };
    var handleResetSelection = function() {
        setSelection([]);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                xs: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: optionColumns.map(function(column, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            md: "6",
                            lg: "4",
                            children: column.map(function(option, index) {
                                var isSelected = getIsSelected(option.value);
                                var count = option.itemCount;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Check */.Z.Check, {
                                    id: "".concat(filter.name, "-").concat(option.value),
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            option.label,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                                                pill: true,
                                                className: "".concat((CheckboxFilterSelector_module_default()).itemCountBadge, " ").concat(!count && isSelected ? (CheckboxFilterSelector_module_default()).warning : ""),
                                                children: count
                                            })
                                        ]
                                    }),
                                    className: (CheckboxFilterSelector_module_default()).checkbox,
                                    type: "checkbox",
                                    checked: isSelected,
                                    onChange: function() {
                                        return handleChangeSelection(option.value);
                                    },
                                    disabled: !count && !isSelected
                                }, index);
                            })
                        }, index);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                xs: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterSelectorButtons/* default */.Z, {
                    handleReset: handleResetSelection,
                    handleApply: applySelection
                })
            })
        ]
    });
};
/* harmony default export */ var CheckboxFilterSelector_CheckboxFilterSelector = (CheckboxFilterSelector);

;// CONCATENATED MODULE: ./src/components/models/travel/filter/TravelFilterNav/selectors/CheckboxFilterSelector/index.tsx



/***/ }),

/***/ 75849:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"FilterSelectorButtons_root__xXKVZ","button":"FilterSelectorButtons_button__7l9zm"};

/***/ }),

/***/ 69664:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"CheckboxFilterSelector_checkbox__8LEaB","itemCountBadge":"CheckboxFilterSelector_itemCountBadge__MVOA8","warning":"CheckboxFilterSelector_warning__4sOU9"};

/***/ }),

/***/ 35005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _restart_ui_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70861);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





const defaultProps = {
  variant: 'primary',
  active: false,
  disabled: false
};
const Button = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  as,
  bsPrefix,
  variant,
  size,
  active,
  className,
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'btn');
  const [buttonProps, {
    tagName
  }] = (0,_restart_ui_Button__WEBPACK_IMPORTED_MODULE_4__/* .useButtonProps */ .FT)({
    tagName: as,
    ...props
  });
  const Component = tagName;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, { ...buttonProps,
    ...props,
    ref: ref,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && props.disabled && 'disabled')
  });
});
Button.displayName = 'Button';
Button.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Button);

/***/ })

}]);